import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './componentAwaiter.html';
import './componentAwaiter.scss';

export interface ComponentAwaiterVMConfig {
    await: SubscribableOrNullableValue<string | Array<string>>
}

@injectable()
export default class ComponentAwaiterVM {
    busyNodes: JQuery<any>
    readyNodes: JQuery<any>

    isLoading: Subscribable<boolean>
    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ComponentAwaiterVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.busyNodes = $(info.templateNodes).filter('awaiter-busy').contents();
        this.readyNodes = $(info.templateNodes).filter('awaiter-ready').contents();

        this.isLoading = ko.fromPromise(async toAwait => {
            if (toAwait != undefined) {
                if (_.isArray(toAwait))
                    await components.await(...toAwait);
                else
                    await components.await(toAwait);
            }

            return false;
        }, [config.await], true).extend({ rateLimit: 250 });

        this.isReady = this.isLoading.not();

        ko.applyBindingsToNode(info.element, {
            'css': {
                'component-awaiter': true
            }
        });
    }
}